import { ReactNode } from 'react';
import { mlyTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={mlyTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
